import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Output,
} from '@angular/core'

/**
 * Sends a `clickOutside` event whenever user clicks outside of the element or its descendants
 * usage: `<div hsOutsideClick (clickOutside)="handleOutsideClick()"/>`
 */
@Directive({
  selector: '[hsOutsideClick]',
})
export class OutsideClickDirective {
  @Output() clickOutside = new EventEmitter<void>()

  constructor(private readonly elementRef: ElementRef) {}

  @HostListener('document:click', ['$event.target'])
  onClick(target: HTMLElement) {
    const clickedInside = this.elementRef.nativeElement.contains(target)
    if (!clickedInside) {
      this.clickOutside.emit()
    }
  }
}
